import PaymentIcon from "@mui/icons-material/Payment";
import permissions from "app/permissions";
import { ACCOMMODATION_PAYMENTS, DormitoryServicePath } from "utils/constants";
import ListAccommodationPayments from "./List";

export const resources = {
  isMenu: true,
  icon: <PaymentIcon />,
  name: DormitoryServicePath + ACCOMMODATION_PAYMENTS,
  title: "Плащания",
  list: <ListAccommodationPayments />,
  permission: permissions.canPreviewDormitoryPayments,
};
